// extracted by mini-css-extract-plugin
module.exports = {"blockLastOrder":"_1rkRJ","reOrder":"_14YWt","orderData":"_2Q3i7","blockButton":"_3XAyY","orderBlockText":"_1cjeb","firstSpan":"_1YrlB","price":"_1RO1e"};